export type CalculatorBootstrapKey = 'jd' | 'pdd'

let activeUserId = ''
const payloads = new Map<CalculatorBootstrapKey, unknown>()
const requests = new Map<CalculatorBootstrapKey, Promise<unknown>>()

export function activateCalculatorBootstrapUser(userId: string) {
  if (userId === activeUserId) return
  activeUserId = userId
  payloads.clear()
  requests.clear()
}

export function clearCalculatorBootstrapCache() {
  activeUserId = ''
  payloads.clear()
  requests.clear()
}

export function peekCalculatorBootstrap<T>(userId: string, key: CalculatorBootstrapKey): T | null {
  if (!userId || userId !== activeUserId) return null
  return (payloads.get(key) as T | undefined) ?? null
}

export function loadCalculatorBootstrap<T>(userId: string, key: CalculatorBootstrapKey, url: string): Promise<T> {
  if (!userId) return Promise.reject(new Error('请先登录'))
  activateCalculatorBootstrapUser(userId)
  const cached = payloads.get(key) as T | undefined
  if (cached) return Promise.resolve(cached)
  const pending = requests.get(key) as Promise<T> | undefined
  if (pending) return pending

  const request = fetch(url, { cache: 'no-store' })
    .then(async (response) => {
      if (!response.ok) throw new Error(`利润计算器数据加载失败：${response.status}`)
      return response.json() as Promise<T>
    })
    .then((payload) => {
      if (activeUserId === userId) payloads.set(key, payload)
      return payload
    })
    .finally(() => {
      if (activeUserId === userId) requests.delete(key)
    })
  requests.set(key, request)
  return request
}

export function preloadCalculatorBootstrap(userId: string, key: CalculatorBootstrapKey, url: string) {
  void loadCalculatorBootstrap(userId, key, url).catch(() => {})
}
